var TEMPLATE_URL = require('./header-nav.html');

angular.module('ikeweb.layout').directive('headerNav',
    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            controller: 'PageHeaderController',
            controllerAs: 'ctrl',
            link: function($scope) {
                $scope.showAccountDropdown = false;

                $scope.toggleDropdown = function($evt) {
                    $evt.stopPropagation();
                    $scope.showAccountDropdown = !$scope.showAccountDropdown;

                    if ($scope.showAccountDropdown) {
                        $('body').on('click.dropdown', function() {
                            $scope.$apply(function() {
                                $scope.showAccountDropdown = false;
                                $('body').off('click.dropdown');
                            });
                        });
                    }
                };
            }
        };
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/layout/header/header-nav.directive.js
// module id = 460
// module chunks = 0